import React, { useState } from "react";
import "../css/contactus.scss";
import brandConfig from "../config";

function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "Game question",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle");
  const change = (event) => {
    setForm((current) => ({
      ...current,
      [event.target.name]: event.target.value,
    }));
    setErrors((current) => ({ ...current, [event.target.name]: "" }));
  };
  const submit = (event) => {
    event.preventDefault();
    const next = {};
    if (!form.name.trim()) next.name = "Enter your name.";
    if (!/^\S+@\S+\.\S+$/.test(form.email)) next.email = "Enter a valid email.";
    if (form.message.trim().length < 10)
      next.message = "Use at least 10 characters.";
    if (Object.keys(next).length) {
      setErrors(next);
      return;
    }
    setStatus("sending");
    window.setTimeout(() => {
      try {
        localStorage.setItem(
          "anackmira_contact_demo",
          JSON.stringify({ ...form, savedAt: new Date().toISOString() })
        );
      } catch (error) {
        console.warn(error);
      }
      setStatus("saved");
      setForm({ name: "", email: "", subject: "Game question", message: "" });
    }, 600);
  };
  return (
    <main className="contact-page page-shell">
      <section className="contact-intro">
        <p className="eyebrow">Contact</p>
        <h1>Talk games with us.</h1>
        <p>
          This page shows the contact details configured for{" "}
          {brandConfig.brandName}, a brand operated by {brandConfig.legalName}.
          The form below saves a local demonstration only—it does not send a
          message.
        </p>
        <div className="contact-details">
          <div>
            <span>Company</span>
            <strong>{brandConfig.legalName}</strong>
          </div>
          <div>
            <span>Email</span>
            <a href={`mailto:${brandConfig.email}`}>{brandConfig.email}</a>
          </div>
          <div>
            <span>Website</span>
            <a href={brandConfig.websiteUrl}>{brandConfig.website}</a>
          </div>
          <div>
            <span>Address</span>
            <address>{brandConfig.address}</address>
          </div>
        </div>
      </section>
      <form className="contact-form" onSubmit={submit} noValidate>
        <div>
          <p className="eyebrow">Local form demo</p>
          <h2>Write a note</h2>
          <p>Nothing leaves this browser.</p>
        </div>
        <label>
          Name
          <input
            name="name"
            value={form.name}
            onChange={change}
            aria-invalid={Boolean(errors.name)}
          />
          {errors.name && <small className="field-error">{errors.name}</small>}
        </label>
        <label>
          Email
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={change}
            aria-invalid={Boolean(errors.email)}
          />
          {errors.email && (
            <small className="field-error">{errors.email}</small>
          )}
        </label>
        <label>
          Topic
          <select name="subject" value={form.subject} onChange={change}>
            <option>Game question</option>
            <option>Purchase demonstration</option>
            <option>Accessibility feedback</option>
            <option>Other</option>
          </select>
        </label>
        <label>
          Message
          <textarea
            name="message"
            rows="6"
            value={form.message}
            onChange={change}
            aria-invalid={Boolean(errors.message)}
          />
          {errors.message && (
            <small className="field-error">{errors.message}</small>
          )}
        </label>
        {status === "saved" && (
          <div className="form-success" role="status">
            Saved locally. No email was sent.
          </div>
        )}
        <button
          className="button button--large"
          type="submit"
          disabled={status === "sending"}
        >
          {status === "sending" ? "Saving locally…" : "Save demo message"}
        </button>
      </form>
    </main>
  );
}

export default Contact;
